// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"280":"bd422b3e","488":"90e2fe10","757":"498774b3"}[chunkId] + ".chunk.js";
};